"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupSizes = void 0;
const _ = require("lodash");
const course_1 = require("../course");
const getGroupSizes = (number_of_golfers, max_pax, tee_time) => {
    let group_sizes = [];
    const new_breakdown = (0, course_1.getGroupSizeBreakdown)(number_of_golfers, max_pax) || [];
    group_sizes = _.cloneDeep(tee_time?.groups || []);
    if (new_breakdown.length < group_sizes.length) {
        group_sizes = group_sizes.slice(0, new_breakdown.length);
        new_breakdown.forEach((group, index) => {
            group_sizes[index].number_of_players = group;
        });
    }
    else {
        new_breakdown.forEach((group, index) => {
            if (group_sizes[index]) {
                group_sizes[index].number_of_players = group;
            }
            else {
                group_sizes.push({
                    number_of_players: group,
                    start_time: "",
                });
            }
        });
    }
    // if the length of the group_sizes is greater than the length of the new_breakdown then remove the extra ones
    if (group_sizes.length > exports.getGroupSizes.length) {
        group_sizes = group_sizes.slice(0, new_breakdown.length);
    }
    return group_sizes;
};
exports.getGroupSizes = getGroupSizes;
